import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M8.846 3.346a.845.845 0 1 0-1.692 0v3.808H3.346a.845.845 0 1 0 0 1.692h3.808v3.808a.845.845 0 1 0 1.692 0V8.846h3.808a.845.845 0 1 0 0-1.692H8.846z"
    }, null, -1)
  ]))]))
}
export default { render: render }